export const CELEBRITY_BENEFITS = [
  {
    title: "셀러브리티 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 뷔페 레스토랑 이용",
      "뷔페 내 물, 커피, 차, 주스 등 기본 음료 제공",
      "선내 공연 및 라이브 음악 등 엔터테인먼트 프로그램",
      "수영장, 피트니스 센터 등 다양한 편의시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ]
  },
  {
    title: "All Included 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "클래식 음료 패키지 포함",
      "무제한 Basic Wi-Fi 포함"
    ],
    notes: [
      "※ All Included는 객실 등급이 아닌 요금제 옵션이며, 선상팁은 불포함 됩니다."
    ]
  },
  {
    title: "Aqua Class 등급 주요 혜택",
    items: [
      "전용 레스토랑 블루(Blu) 이용",
      "웰니스 및 스파 콘셉트 객실 제공",
      "스파·웰니스 관련 어메니티 제공",
      "SEA Thermal Suite 또는 Persian Garden 이용 혜택",
      "건강하고 가벼운 스타일의 다이닝 경험 제공"
    ]
  },
  {
    title: "The Retreat Suite 등급 주요 혜택",
    items: [
      "선상 팁 포함",
      "프리미엄 음료 패키지 포함",
      "프리미엄 Wi-Fi 포함",
      "전용 레스토랑 루미나(Luminae) 이용",
      "The Retreat Lounge 및 전용 공간 이용",
      "우선 승하선 서비스",
      "24시간 룸서비스 무료 제공",
      "버틀러 서비스 제공",
      "기항지 관광 상담을 위한 Destination Experience Specialist 서비스 제공",
      "Private Journeys 이용 시 버틀러의 스위트-차량 에스코트 서비스 제공",
      "프리미엄 Celebrity 욕실 어메니티 제공"
    ]
  },
  {
    title: "Royal Suite 이상 추가 혜택",
    items: [
      "The Retreat Suite 등급 혜택 +",
      "Extend Your Stay 프로그램 무료 제공",
      "SEA Thermal Suite 및 Persian Garden 무료 이용",
      "매일 무료 세탁 및 무제한 다림질 서비스 제공",
      "무료 미니바 개인 맞춤 구성",
      "전용 슬립웨어 제공",
      "스페셜티 레스토랑 무료 이용",
      "스페셜티 레스토랑 런치 포함"
    ],
    notes: [
      "※ 선박, 선실 등급, 항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const CUNARD_BENEFITS = [
  {
    title: "큐나드 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "나이틀리 턴다운 서비스",
      "아침/점심/저녁 식사 포함",
      "객실 등급에 따른 전용 메인 다이닝 레스토랑 이용",
      "뷔페 및 일부 캐주얼 다이닝 이용",
      "룸서비스 이용",
      "애프터눈 티 제공",
      "선내 공연 및 라이브 음악 등 엔터테인먼트 프로그램",
      "댄스 클래스, 강연, 일부 선내 프로그램 참여 가능",
      "수영장, 피트니스 센터, 스포츠 시설 등 다양한 편의시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ]
  },
  {
    title: "Cunard Signature Package 선택 시 추가 혜택 (부가서비스)",
    items: [
      "음료 패키지 포함",
      "Wi-Fi 패키지 포함",
      "대체 레스토랑 이용 시 사용 가능한 다이닝 크레딧 제공"
    ],
    notes: [
      "※ Cunard Signature Package는 일부 항차에서 선택 가능한 유료 추가 패키지"
    ]
  },
  {
    title: "Britannia Club 등급 주요 혜택",
    items: [
      "Britannia Club 전용 레스토랑 이용",
      "전용 테이블 제공",
      "운영 시간 내 자유로운 다이닝 이용",
      "Britannia 객실 대비 한층 여유로운 다이닝 서비스 제공"
    ]
  },
  {
    title: "Princess Grill Suite 등급 주요 혜택",
    items: [
      "넓은 발코니 스위트 객실 제공",
      "Princess Grill 전용 레스토랑 이용",
      "전용 테이블 제공",
      "Grills Lounge 및 Grills Terrace 이용",
      "고급 목욕가운 및 슬리퍼 제공",
      "무료 생수 제공",
      "Penhaligon's 욕실 어메니티 제공",
      "Grill Suites 애프터눈 티 제공"
    ]
  },
  {
    title: "Queens Grill Suite 등급 주요 혜택",
    items: [
      "넓은 최상위 스위트 객실 제공",
      "Queens Grill 전용 레스토랑 이용",
      "전용 테이블 제공",
      "Grills Lounge 및 Grills Terrace 이용",
      "개인 버틀러 서비스 제공",
      "객실 내 다이닝 서비스 제공",
      "오프 메뉴 주문 가능",
      "웰컴 샴페인 및 초콜릿 제공",
      "고급 목욕가운 및 슬리퍼 제공",
      "무료 생수 제공",
      "Penhaligon's 욕실 어메니티 제공",
      "Grill Suites 애프터눈 티 제공"
    ],
    notes: [
      "※ Princess Grill 및 Queens Grill은 Grills Suite 카테고리로, 전용 레스토랑과 Grills Lounge/Terrace 등 별도 혜택이 제공됩니다. Queens Grill은 개인 버틀러 서비스가 제공되는 최상위 스위트 등급입니다.",
      "※ 선상팁, Wi-Fi, 음료 패키지, 기항지 관광, 스파 및 살롱 등은 별도 비용이 발생할 수 있으며, 선박·선실 등급·항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있습니다."
    ]
  }
];

export const CARNIVAL_BENEFITS = [
  {
    title: "카니발 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 Lido 뷔페 레스토랑 이용",
      "일부 캐주얼 다이닝(Guy's Burger Joint, BlueIguana Cantina, Big Chicken 등) 무료 이용",
      "피자, 소프트 아이스크림 및 프로즌 요거트 제공",
      "뷔페 및 메인 다이닝 내 물, 레모네이드, 아이스티, 핫초코, 일반 커피, 차 등 기본 음료 제공",
      "조식 룸서비스 중 컨티넨탈 조식 무료 제공",
      "라이브 음악, 코미디 쇼, 파티 등 일부 선내 프로그램 이용",
      "수영장, 워터파크, 피트니스 센터 등 다양한 편의시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ],
    notes: [
      "※ 메인 다이닝 저녁 식사 시 메인 요리는 1인당 2개까지 무료이며, 3번째 메인 요리부터 추가 비용이 발생할 수 있습니다."
    ]
  },
  {
    title: "특수 객실 카테고리 - Cloud 9 Spa 객실 주요 혜택",
    items: [
      "Cloud 9 Spa 인근 객실 배정",
      "Thermal Suite 무제한 이용",
      "스크럽 키트 제공",
      "1인당 피트니스 클래스 2회 무료 제공",
      "체성분 분석 서비스 제공",
      "항구 정박일 스파 트리트먼트 할인 혜택",
      "Cloud 9 Spa 목욕가운 및 슬리퍼 제공",
      "업그레이드된 Elemis 객실 욕실 어메니티 제공"
    ],
    notes: [
      "※ Cloud 9 Spa 전용 공간은 선박별 구성 및 이용 시간에 따라 상이할 수 있습니다."
    ]
  },
  {
    title: "특수 객실 카테고리 - Havana 객실 주요 혜택",
    items: [
      "쿠바 스타일 콘셉트 객실 제공",
      "Havana Pool Area 전용 이용",
      "Havana Bar 및 라운지 공간 이용",
      "한적한 전용 휴식 공간 이용 가능"
    ],
    notes: [
      "※ Havana 전용 공간은 선박별 구성 및 이용 시간에 따라 상이할 수 있습니다."
    ]
  },
  {
    title: "특수 객실 카테고리 - Family Harbor 객실 주요 혜택",
    items: [
      "가족 여행객 특화 객실 제공",
      "Family Harbor Lounge 전용 이용",
      "보드게임, 가족 영화, 비디오게임 등 라운지 콘텐츠 이용",
      "어린이 동반 고객 대상 일부 스페셜티 레스토랑 어린이 메뉴 무료 제공",
      "Camp Ocean Night Owls 베이비시팅 서비스 1회 무료 제공",
      "Family Harbor 목욕가운 제공"
    ],
    notes: [
      "※ Family Harbor 전용 공간은 선박별 구성 및 이용 시간에 따라 상이할 수 있습니다."
    ]
  },
  {
    title: "Carnival Suite 등급 주요 혜택",
    items: [
      "넓은 스위트 객실 제공",
      "우선 체크인 및 승선 혜택",
      "승선 후 스위트 객실 우선 이용 가능",
      "메인 다이닝 시간 우선 배정",
      "스페셜티 레스토랑 우선 예약 혜택",
      "하선 및 텐더 보트 이용 시 우선 서비스",
      "무료 세탁 서비스 제공",
      "대용량 생수 제공",
      "고급 욕실 어메니티 제공"
    ],
    notes: [
      "※ 선상팁, Wi-Fi, 음료 패키지, 기항지 관광 등은 별도 비용이 발생할 수 있으며, 선박·선실 등급·항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있습니다."
    ]
  }
];

export const COSTA_BENEFITS = [
  {
    title: "코스타 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 뷔페 레스토랑 이용",
      "뷔페 내 물, 일반 커피, 차 등 기본 음료 제공",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "라이브 음악, 파티 등 일부 선내 프로그램 이용",
      "수영장, 피트니스 센터 등 다양한 편의시설 이용",
      "스포츠 및 웰니스 시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ]
  },
  {
    title: "Costa All Inclusive 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "My Drinks 음료 패키지 포함",
      "식사 시간 및 바에서 일부 주류·무알코올 음료 이용 가능",
      "칵테일, 와인, 맥주, 탄산음료, 커피류 등 일부 음료 포함"
    ]
  },
  {
    title: "Costa Suite 등급 이상 추가 혜택",
    items: [
      "넓은 스위트 객실 제공",
      "개인 버틀러 서비스 제공",
      "스위트 전용 레스토랑 이용",
      "My Drinks Plus 음료패키지 적용 (프리미엄 주류, 미니바 포함)",
      "무료 룸서비스 제공",
      "우선 승선 혜택",
      "우선 레스토랑 예약 혜택",
      "웰컴 스파클링 와인 및 카나페 제공",
      "객실 내 과일, 커피 머신 제공",
      "전용 어메니티 제공",
      "일부 스파/웰니스 혜택 제공",
      "전용 이벤트 및 일부 선내 프로그램 우선 이용 혜택",
      "쇼핑 및 기항지 관광 예약 상담 지원"
    ],
    notes: [
      "※ 선상팁, Wi-Fi, 음료 패키지, 기항지 관광 등은 별도 비용이 발생할 수 있으며, 선박·선실 등급·항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있습니다."
    ]
  }
];

export const HOLLAND_AMERICA_BENEFITS = [
  {
    title: "홀랜드 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 Lido Market 뷔페 레스토랑 이용",
      "일부 캐주얼 다이닝 이용",
      "뷔페 및 메인 다이닝 내 물, 일반 커피, 차 등 기본 음료 제공",
      "룸서비스 이용 가능",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "라이브 음악 및 뮤직 워크 등 일부 선내 프로그램 이용",
      "수영장, 피트니스 센터, 스포츠 시설 등 다양한 편의시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ]
  },
  {
    title: "Have It All 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "기항지 관광 크레딧 제공",
      "Signature 음료 패키지 포함",
      "Wi-Fi Surf 패키지 포함",
      "스페셜티 다이닝 이용 혜택",
      "선상팁 포함"
    ],
    notes: [
      "※ 기항지 관광 크레딧과 스페셜티 다이닝 횟수는 항차에 따라 달라질 수 있습니다."
    ]
  },
  {
    title: "Signature Beverage Package 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "와인, 맥주, 주류, 칵테일 일부 포함",
      "탄산음료, 스페셜티 커피 등 일부 무알코올 음료 포함",
      "음료 서비스 차지 포함"
    ],
    notes: [
      "※ Signature Beverage Package는 1일 음료 제한 및 금액 제한이 있을 수 있습니다."
    ]
  },
  {
    title: "Vista Suite 등급 주요 혜택",
    items: [
      "발코니가 포함된 스위트 객실 제공",
      "일반 객실보다 넓은 객실 공간 제공",
      "별도 휴식 공간 제공",
      "프리미엄 침구 및 객실 어메니티 제공",
      "목욕가운 및 욕실 어메니티 제공"
    ]
  },
  {
    title: "Signature Suite 등급 주요 혜택",
    items: [
      "Vista Suite보다 넓은 스위트 객실 제공",
      "넓은 휴식 공간 및 발코니 제공",
      "Mariner's Dream 침구 제공",
      "프리미엄 욕실 어메니티 제공",
      "목욕가운 및 슬리퍼 제공",
      "넓은 욕실 및 수납 공간 제공"
    ]
  },
  {
    title: "Neptune Suite 등급 주요 혜택",
    items: [
      "넓은 스위트 객실 제공",
      "Neptune Lounge 전용 이용",
      "전용 컨시어지 서비스 제공",
      "우선 승선 및 하선 혜택 제공 가능",
      "우선 다이닝 및 스페셜티 레스토랑 예약 혜택 제공 가능",
      "객실 내 무료 미니바 또는 일부 객실 어메니티 제공 가능",
      "세탁 및 드라이클리닝 서비스 혜택 제공 가능",
      "고급 욕실 어메니티 및 목욕가운 제공 가능"
    ]
  },
  {
    title: "Pinnacle Suite 등급 주요 혜택",
    items: [
      "최상위 스위트 객실 제공",
      "Neptune Suite 혜택 포함",
      "Neptune Lounge 전용 이용",
      "전용 컨시어지 서비스 제공",
      "우선 체크인 혜택",
      "무료 세탁, 다림질 및 드라이클리닝 서비스 제공",
      "넓은 거실, 다이닝 공간 및 침실 제공",
      "대형 발코니 또는 월풀 발코니 제공 가능",
      "고급 욕실 및 별도 드레싱 공간 제공",
      "최상위 객실 어메니티 제공"
    ],
    notes: [
      "※ Neptune Lounge 및 전용 컨시어지 서비스는 Pinnacle Suite와 Neptune Suite 고객에게 제공됩니다.",
      "※ 선상팁, Wi-Fi, 음료 패키지, 기항지 관광, 스페셜티 다이닝 등은 기본 요금에는 별도이며, Have It All 요금 선택 시 일부 혜택이 포함됩니다.",
      "※ 선박, 선실 등급, 항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const PRINCESS_BENEFITS = [
  {
    title: "프린세스 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 뷔페 레스토랑 이용",
      "일부 캐주얼 다이닝 이용",
      "뷔페 및 메인 다이닝 내 물, 일반 커피, 차 등 기본 음료 제공",
      "룸서비스 이용 가능",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "Movies Under the Stars 등 일부 선내 프로그램 이용",
      "수영장, 피트니스 센터, 스포츠 시설 등 다양한 편의시설 이용",
      "어린이/청소년 프로그램 이용",
      "일부 선내 액티비티 프로그램 참여 가능"
    ]
  },
  {
    title: "Princess Plus 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "Plus 음료 패키지 포함",
      "Wi-Fi 1기기 포함",
      "Crew Appreciation, 선상팁 포함",
      "캐주얼 다이닝 일부 이용 혜택",
      "OceanNow 및 룸서비스 배송비 면제"
    ]
  },
  {
    title: "Princess Premier 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "Premier 음료 패키지 포함",
      "Wi-Fi 4기기 포함",
      "Crew Appreciation, 선상팁 포함",
      "스페셜티 다이닝 이용 혜택",
      "캐주얼 다이닝 이용 혜택",
      "전문 사진 패키지 혜택",
      "일부 공연 예약 좌석 혜택",
      "기항지 관광 크레딧 제공 가능"
    ]
  },
  {
    title: "Reserve Collection 등급 주요 혜택",
    items: [
      "프리미엄 위치의 미니 스위트 객실 제공",
      "Reserve Dining 전용 공간 이용",
      "예약 없이 유연한 다이닝 이용",
      "전용 직원 서비스 제공",
      "객실 내 와인 세팅 제공",
      "추가 어메니티 제공",
      "우선 승하선 혜택 제공 가능"
    ]
  },
  {
    title: "Suite 등급 주요 혜택",
    items: [
      "Reserve Collection 등급 혜택 포함 +",
      "넓은 스위트 객실 제공",
      "스페셜티 레스토랑 조식 무료제공",
      "승선일 스페셜티 레스토랑 저녁 식사 무료 제공",
      "미니바 세팅 무료 제공",
      "세탁 및 전문 클리닝 서비스 무료 제공",
      "Suite Lounge 이용 가능",
      "업그레이드된 욕실 및 객실 어메니티 제공",
      "웰컴 와인 및 이브닝 카나페 제공"
    ],
    notes: [
      "※ Suite 등급은 Reserve Collection 혜택을 포함하며, 여기에 스위트 전용 추가 혜택이 제공됩니다.",
      "※ Reserve Collection 및 일반 Suite 등급에는 Princess Plus 또는 Princess Premier 패키지가 자동 포함되지 않습니다."
    ]
  },
  {
    title: "Sanctuary Collection 주요 혜택 (Sun Princess, Star Princess 해당)",
    items: [
      "Princess Premier 부가서비스 혜택 포함 +",
      "The Sanctuary Club 전용 공간 이용",
      "Sanctuary Restaurant 전용 다이닝 이용",
      "전용 직원 서비스 제공",
      "예약 없이 유연한 전용 다이닝 이용",
      "고급 어메니티 제공"
    ],
    notes: [
      "※ Sanctuary Collection은 Princess Premier 패키지가 포함된 프리미엄 객실 컬렉션입니다.",
      "※ 선박, 선실 등급, 항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const REGENT_SEVEN_SEAS_BENEFITS = [
  {
    title: "리젠트 세븐시즈 크루즈 기본혜택",
    items: [
      "전 객실 스위트 객실 제공",
      "전 객실 발코니 제공 (네비게이터 제외)",
      "아침/점심/저녁 식사 및 스페셜티 레스토랑 무료 이용",
      "객실 정비 서비스",
      "24시간 인스위트 다이닝 서비스",
      "무제한 기항지 투어 제공",
      "고급 와인, 샴페인, 주류, 칵테일, 스페셜티 커피, 차, 생수, 탄산음료 등 포함",
      "객실 내 미니바 무료 제공 및 리필",
      "전 일정 무제한 Wi-Fi 제공",
      "선상 팁 포함",
      "발렛 세탁 서비스 포함",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "수영장, 피트니스 센터, 스파 등 다양한 편의시설 이용"
    ]
  },
  {
    title: "Concierge Suite 이상 추가 혜택",
    items: [
      "출발 전 1박 호텔 제공"
    ]
  },
  {
    title: "Penthouse Suite 이상 추가 혜택",
    items: [
      "개인 버틀러 서비스 제공"
    ],
    notes: [
      "※ 항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const OCEANIA_BENEFITS = [
  {
    title: "오세아니아 크루즈 기본혜택",
    items: [
      "객실 정비 서비스",
      "아침/점심/저녁 식사 포함",
      "메인 다이닝 및 뷔페 레스토랑 이용",
      "스페셜티 레스토랑 무료 이용",
      "스페셜티 커피, 탄산음료, 차, 주스, 스무디, 생수 등 기본 음료 제공",
      "전 일정 무제한 Wi-Fi 제공",
      "선상팁 포함",
      "24시간 룸서비스 무료",
      "셀프 세탁 서비스 제공",
      "선내 그룹 피트니스 클래스 이용",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "수영장, 피트니스 센터 등 다양한 편의시설 이용"
    ]
  },
  {
    title: "Your World Included 요금 선택 시 추가 혜택 (부가서비스)",
    items: [
      "기항지 관광 크레딧 제공",
      "또는 점심/저녁 식사 시간 와인·맥주 제공"
    ],
    notes: [
      "※ 예약 조건에 따라 선택 가능한 혜택이 상이할 수 있습니다."
    ]
  },
  {
    title: "Concierge Level 등급 주요 혜택",
    items: [
      "우선 승하선 혜택",
      "무료 세탁 서비스",
      "전담 컨시어지 서비스",
      "The Grand Dining Room 메뉴 룸서비스 제공",
      "Aquamar Spa Terrace 이용",
      "우선 스페셜티 레스토랑 예약 제공",
      "Concierge Lounge 이용 (일부 선박)"
    ]
  },
  {
    title: "Suite 이상 추가 혜택",
    items: [
      "Concierge Level 혜택 포함 +",
      "넓은 스위트 객실 제공",
      "24시간 버틀러 서비스 제공",
      "Executive Lounge 전용 이용",
      "스위트 내 다이닝 서비스 제공",
      "객실 내 바 세팅 제공",
      "웰컴 샴페인 또는 프로세코 제공",
      "의류 프레싱 서비스 제공",
      "우선 수하물 배송",
      "우선 온라인 스페셜티 레스토랑 예약"
    ],
    notes: [
      "※ 선박, 선실 등급, 항차 및 프로모션 조건에 따라 포함 사항이 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const EXPLORA_BENEFITS = [
  {
    title: "익스플로라 크루즈 기본혜택",
    items: [
      "전 객실 오션 프론트 스위트 객실 제공",
      "아침/점심/저녁 식사 포함",
      "9개의 다이닝 경험 및 인스위트 다이닝 포함 (단, Anthology 제외)",
      "고급 와인, 샴페인, 프리미엄 주류, 스페셜티 커피, 차, 탄산음료 등 무제한 제공",
      "객실 내 웰컴 샴페인 1병 제공",
      "객실 내 선호 와인 1병 및 스피릿 1병 제공",
      "전 일정 고속 Wi-Fi 제공",
      "선상팁 포함",
      "Ocean Wellness - The Spa thermal area 이용",
      "그룹 웰니스, 피트니스 및 마인드풀니스 프로그램 이용",
      "전문 호스피탈리티 팀의 맞춤형 서비스 제공",
      "항구-도심 셔틀 서비스 제공",
      "선내 공연 및 다양한 엔터테인먼트 프로그램",
      "수영장, 피트니스 센터 등 다양한 편의시설 이용"
    ]
  },
  {
    title: "Ocean Penthouses 이상 추가 혜택",
    items: [
      "다이닝 예약 우선 이용",
      "객실 내 와인 또는 스피릿 1병 추가 제공",
      "프라이빗 셀러 와인 일부 할인 혜택",
      "체크인 후 24시간 이내 의류 프레싱 서비스 1회 제공",
      "여정당 세탁 1백 제공",
      "우선 체크인 및 승선 서비스 제공"
    ]
  },
  {
    title: "Ocean Residences 이상 추가 혜택",
    items: [
      "Ocean Penthouses 혜택 포함 +",
      "전용 메뉴가 포함된 인스위트 다이닝 서비스",
      "객실 내 풀 바 세팅 제공",
      "인스위트 트레이닝을 위한 Technogym Case Kit 제공",
      "개인 맞춤 서비스 제공",
      "무료 세탁 및 다림질 서비스 무제한 제공",
      "Residence Host의 상위 객실 서비스 제공",
      "우선 승선 및 수하물 서비스 제공",
      "항구·호텔·공항 간 프라이빗 교통편 제공"
    ],
    notes: [
      "※ 항구-도심 셔틀 서비스 및 일부 추가 혜택은 항차, 선박, 선실 등급 및 프로모션 조건에 따라 상이할 수 있으니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

export const EXTRA_LINE_BENEFITS_BY_ID = {
  3: CELEBRITY_BENEFITS,
  5: CUNARD_BENEFITS,
  8: CARNIVAL_BENEFITS,
  9: COSTA_BENEFITS,
  15: HOLLAND_AMERICA_BENEFITS,
  20: PRINCESS_BENEFITS,
  21: REGENT_SEVEN_SEAS_BENEFITS,
  48: OCEANIA_BENEFITS,
  849: EXPLORA_BENEFITS,
};
